import { createRoute } from '@tanstack/react-router';
import { Route as shellRoute } from './_shell';
import { ActionInbox } from '@/features/home/ActionInbox';

/** The full inbox: the same rows as Home, without the top eight limit. */
function InboxPage() {
  return <ActionInbox limit={50} showViewAll={false} />;
}

export const Route = createRoute({
  getParentRoute: () => shellRoute,
  path: '/inbox',
  component: InboxPage,
});
